import { TaskFilters } from './task-filters.model';

export class TaskQueryParams extends TaskFilters {
  userId?: string | null;
  includeGroupTasks?: boolean | null;
  showCompleted?: boolean | null;
  sort?: string | null;
  asc?: boolean | null;
  skip?: number | null;
  take?: number | null;
  exactMatch?: boolean | null;
  applicationId?: string;
  categoryId?: string | null;
  standaloneTasks?: boolean | null;
}
